// // src/contexts/ConfigContext.js
import React, { createContext, useEffect, useState } from "react";
import axios from 'axios';
import { fetchWithRetry } from "../utils/fetchWithRetry";
import { Helmet } from "react-helmet";


const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState([]);
  const [configLoading, setLoadingConfig] = useState(false);
  const [configError, setErrorConfig] = useState(null);

  const CONFIG_API_URL =
    'https://admin.thirsty-shtern.91-151-16-181.plesk.page/items/Konfiguration';

  useEffect(() => {
    const ac = new AbortController();
    const fetchConfig = async () => {
      setLoadingConfig(true); setErrorConfig(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(CONFIG_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        console.log(res);
        setConfig(res?.data?.data ?? []);
      } catch (e) {
        if (!ac.signal.aborted) setErrorConfig('Error');
      } finally {
        if (!ac.signal.aborted) setLoadingConfig(false);
      }
    };
    fetchConfig();
    /* return () => ac.abort(); */
  }, []);

  return (
    <ConfigContext value={{ config, configLoading, configError }}>
      {/* <Helmet> */}
        <style type="text/css">
          {`
            :root {
              --primary: ${config.Primaerfarbe};
              --accent: ${config.Akzentfarbe};
            }
          `}
        </style>
      {/* </Helmet> */}
      {console.log(config)}
      {children}
    </ConfigContext>
  );
};

/* export const useConfig = () => useContext(ConfigContext); */
